import { useMsal } from '@azure/msal-react';

export default (onSuccess: (accessToken: string) => void, onError: (error: any) => void) => {
    const { instance } = useMsal();
    return (scopes: string[]) => {
        return async () => {
            try {
                const loginResponse = await instance.loginPopup({
                    scopes,
                    prompt: 'select_account'
                });
                const { accessToken, scopes: grantedScopes = [] } = loginResponse;

                if (!scopes.every((scope) => grantedScopes.includes(scope))) {
                    throw new Error('scope_not_granted');
                }

                if (accessToken) {
                    onSuccess(accessToken);
                } else {
                    throw new Error('no_access_token');
                }
            } catch (error) {
                const errorMessage = error.message || 'unknown_error';

                if (errorMessage.includes('access_denied')) {
                    onError(new Error('access_denied'));
                } else {
                    onError(new Error(errorMessage));
                }
            }
        };
    };
};
